/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function HardDrives(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Rect x={40} y={144} width={176} height={64} rx={8} opacity={0.2} />
      <Rect x={40} y={48} width={176} height={64} rx={8} opacity={0.2} />
      <Rect
        x={40}
        y={144}
        width={176}
        height={64}
        rx={8}
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Rect
        x={40}
        y={48}
        width={176}
        height={64}
        rx={8}
        strokeWidth={16}
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Circle cx={180} cy={80} r={12} />
      <Circle cx={180} cy={176} r={12} />
    </Svg>
  );
}

export default HardDrives;
